// Contratos del modo "Ver como" (suplantación de solo lectura, SA4).
//
// Un directivo/super_admin puede "actuar como" un usuario de rol inferior de su
// tenant (coordinador, supervisor, líder, técnico o coordinador de mtto) y ver
// EXACTAMENTE los datos y pantallas de esa persona. El backend re-deriva el
// contexto por `user_id` (ver middleware requireAuth) → todos los endpoints de
// ese rol responden como el usuario objetivo. Toda escritura queda bloqueada.
import { z } from 'zod';
/** Roles de plataforma que un directivo puede suplantar (hacia abajo). */
export const rolSuplantableSchema = z.enum(['coordinador', 'supervisor', 'lider']);
/** Rol de módulo de mantenimiento suplantable. */
export const rolMttoSuplantableSchema = z.enum(['tecnico', 'coordinador_mtto']);
/** Persona de rol de plataforma en el roster de "Ver como". */
export const verComoUsuarioSchema = z.object({
    user_id: z.string().uuid(),
    nombre: z.string(),
    apellido: z.string(),
    /** Plantas que gestiona/cubre (nombres). Vacío = sin asignación explícita. */
    plantas: z.array(z.string()),
    /**
     * ¿Está programado/activo en el DÍA OPERATIVO actual? Para líder/supervisor
     * indica que suplantarlo cae en una pantalla útil (no en "sin asignación hoy").
     * Coordinador siempre true (sus pantallas de análisis no dependen del turno).
     */
    activo_hoy: z.boolean(),
    /** Detalle de la programación de hoy (ej. "Línea V1 · T2" / "T1"). null si no aplica. */
    detalle_hoy: z.string().nullable(),
});
/** Persona del módulo de mantenimiento en el roster. */
export const verComoUsuarioMttoSchema = z.object({
    user_id: z.string().uuid(),
    nombre: z.string(),
    apellido: z.string(),
    rol_mtto: rolMttoSuplantableSchema,
    /** Planta de la asignación de módulo. null = cubre todas las plantas. */
    planta: z.string().nullable(),
});
/** Respuesta del roster: personas suplantables agrupadas por rol. */
export const verComoRosterSchema = z.object({
    coordinadores: z.array(verComoUsuarioSchema),
    supervisores: z.array(verComoUsuarioSchema),
    lideres: z.array(verComoUsuarioSchema),
    mantenimiento: z.array(verComoUsuarioMttoSchema),
});
/** Body para registrar el inicio de una sesión de suplantación (auditoría). */
export const verComoInicioSchema = z.object({
    user_id_suplantado: z.string().uuid(),
});
//# sourceMappingURL=ver_como.js.map